class SelectButton {
    constructor(element) {
        this.element = element
        this.selectors = {
            select: '.js-select',
            content: '.js-select-content',
            button: '.js-select-button',
            wrapper: '.js-select-wrapper',
        }
        this.button = $(element).find(this.selectors.button)
        this.select = $(element).find(this.selectors.select)
        this.content = $(element).find(this.selectors.content)
        this.selectIsVisible = false;
        this.element._SelectButton = this

        this.initListeners()
    }

    showSelect() {
        $(this.content).removeClass('hide');
        $(this.button).addClass('hide');
        this.selectIsVisible = true;
    }

    hideSelect() {
        $(this.content).addClass('hide');
        $(this.button).removeClass('hide');
        this.selectIsVisible = false;
    }

    toggleSelect(visible) {
        if (typeof visible !== 'boolean') {
            visible = !this.selectIsVisible;
        }
        visible ? this.showSelect() : this.hideSelect();
    }

    initListeners() {
        this.initClickListener()
        this.initOptionChangedListener()
        this.initBodyClickListener()
    }

    destroy() {
        $('body').off('click', this.initBodyClickHandler)
    }

    initBodyClickListener() {
        $('body').on('click', this.initBodyClickHandler)
    }

    initBodyClickHandler = function (e) {
        const closestWrapper = e.target.closest(this.selectors.wrapper)
        if (closestWrapper !== this.element)
            this.hideSelect()
    }.bind(this)

    initClickListener() {
        $(this.button).on('click', () => this.toggleSelect());
    }

    initOptionChangedListener() {
        $(this.select).on('option:changed', () => this.hideSelect())
    }
}

const selectWrapper = $('.js-select-wrapper')

if (selectWrapper.length) {
    selectWrapper.each((i, item) => new SelectButton(item))
}
